<style scoped lang="less">
	@import "../../assets/less/base.less";
	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		background-color: #ff8358;
		color: #fff;
		a {
			color: #fff;
		}
	}
	
	.el-dropdown-menu__item,
	.el-dropdown-menu__item:not(.is-disabled) {
		a {
			color: #666;
		}
	}
	
	.common-head {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 999;
		width: 100%;
		height: 70px;
		padding: 10px 0;
		background: @active-color;
		color: #fff;
		text-align: center;
		#logo {
			width: 211px;
			height: 41px;
			background: url("../../assets/images/umeng-home-logo.png") no-repeat;
			background-size: contain;
			text-indent: -200em;
			margin-top: 4px;
			margin-left: 13px;
		}
		.msg-box {
			height: 50px;
			line-height: 50px;
			width: 50%;
			>div {
				&.exit-box {
					width: 70px;
					height: 50px;
					line-height: 50px;
					border-left: 2px solid #5c88e9;
					a {
						cursor: pointer;
					}
				}
				&.user-msg {
					padding: 0 30px;
					cursor: pointer;
					.el-dropdown {
						color: #fff;
					}
				}
				&.notice-box {
					position: relative;
					cursor: pointer;
					.notice-num {
						position: absolute;
						top: 10px;
						right: -6px;
						width: 18px;
						height: 18px;
						line-height: 18px;
						text-align: center;
						font-size: 12px;
						background: #ff8358;
						border-radius: 50%;
						transform: scale(0.7);
					}
				}
			}
		}
	}
	
	.el-popover {
		h3 {
			height: 30px;
			line-height: 30px;
			padding: 0 10px;
			border-bottom: 1px solid #eee;
		}
		.notice-list {
			max-height: 264px;
			min-height: 150px;
			padding: 10px;
			font-size: 14px;
			line-height: 24px;
			overflow-y: scroll;
			margin-bottom: 10px;
			li {
				cursor: pointer;
				.notice-title {
					position: relative;
					height: 26px;
					line-height: 26px;
					padding-left: 14px;
					.red-circle {
						position: absolute;
						top: 6px;
						left: 0;
						width: 10px;
						height: 10px;
						background: red;
						border-radius: 50%;
					}
					p {
						width: calc(~"100% - 100px");
					}
				}
				.notice-detail {
					padding: 4px 5px 4px 13px;
					border-bottom: 1px solid #eee;
				}
			}
		}
		.notice-footer {
			text-align: center;
			border-top: 1px solid #eee;
		}
	}
</style>
<template>
	<div class="common-head clear">
		<div id="logo" class="lt">万咖智星广告平台</div>
		<div class="msg-box rt">
			<div class="rt exit-box">
				<a @click.stop="logout"><i class="iconfont icon-umeng-exit" id="exit"></i></a>
			</div>
			<div class="rt user-msg">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link">
                        {{username}}<i class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
					<el-dropdown-menu slot="dropdown" placement="bottom" selfRefs="accountMsg">
						<el-dropdown-item>
							<router-link :to="{name: 'accountCenter'}" tag="a">
								帐号中心
							</router-link>
						</el-dropdown-item>
						<el-dropdown-item>
							<router-link :to="{name: 'modifyPassword'}" tag="a">
								密码修改
							</router-link>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<div class="rt notice-box">
				<el-popover ref="noticeList" placement="bottom" width="400" trigger="click" @hide="hideDetail" :value="showModal">
					<h3 class="">通知</h3>
					<ul class="notice-list">
						<li class="clear" v-for="(item, index) in list" :key="index">
							<div class="notice-title" @click="showDetail(index)">
								<span class="lt red-circle" v-show="item.status==1"></span>
								<p class="lt text-ellipsis">{{item.title}}</p>
								<span class="rt">{{item.ctime| formatDate}}</span>
							</div>
							<p class="notice-detail" v-show="currentIndex===index">{{item.content}}</p>
						</li>
					</ul>
					<div class="notice-footer">
						<el-pagination small @current-change="handleCurrentChange" :current-page.sync="pn" layout="prev, pager, next" :page-size="rn" :total="totalCnt">
						</el-pagination>
					</div>
				</el-popover>
				<div ref="noticeBtn" v-popover:noticeList @click="getNoticeList">
					<i class="iconfont icon-umeng-notice"></i>
					<span class="notice-num">{{unread_cnt}}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import eventBus from '../../eventBus/eventBus.js'
	import { axiosGet, axiosPost } from "../../axios/axios"
	import { MESSAGE_TITLE } from '../../assets/js/const.js'

	export default {
		components: {},
		props: {},
		data() {
			return {
				userMsgUrl: '/home/user/info',
				username: '',
				unread_cnt: '',
				noticeUrl: '/home/list/notice',
				readNoticeUrl: '/home/read/notice',
				currentIndex: null,
				showModal: false,
				list: [],
				pn: 1,
				rn: 10,
				totalCnt: 0,
			}
		},
		filters: {
			//格式化时间戳
			formatDate(time) {
				var date = new Date(time * 1000);
				return _.TimestampToTime(date, 'yyyy-MM-dd');
			}
		},
		methods: {
			handleCurrentChange(p) {
				this.pn = p;
				this.getNoticeList();
			},
			getUserMsg() {
				let result = axiosGet(this.userMsgUrl);
				result.then((response) => {
					if(response.data.error_code == 0) {
						this.username = response.data.userInfo.username;
						this.unread_cnt = response.data.noticeInfo.unread_cnt;
					}
				}, (error) => {
					console.log(error);
				})
			},
			getNoticeList() {
				let result = axiosPost(this.noticeUrl, {
					pn: this.pn
				});
				result.then((response) => {
					if(response.data.error_code == 0) {
						this.list = response.data.list;
						this.pn = Number(response.data.pn);
						this.totalCnt = Number(response.data.totalCnt);
					}
				}, (error) => {
					console.log(error);
				})
			},
			showDetail(index) {
				this.currentIndex == index ? this.currentIndex = null : this.currentIndex = index;
				if(this.list[index] && this.list[index]['status'] == 1) {
					let result = axiosGet(this.readNoticeUrl, {
						id: this.list[index]['id']
					});
					result.then((response) => {
						if(response.data.error_code == 0) {
							//手动修改未读状态和通知条数
							this.list[index]['status'] = 2;
							this.unread_cnt = (this.unread_cnt > 0 ? this.unread_cnt - 1 : 0);
						}
					}, (error) => {
						console.log(error);
					})
				}
			},
			hideDetail: function() {
				//关闭时清除默认
				this.currentIndex = null;
				this.showModal = false;
			},
			//退出登录
			logout() {
				this.$alert('是否退出登录', MESSAGE_TITLE, {
					confirmButtonText: '确定',
					callback: action => {
						if(action == 'confirm') {
							axiosPost('/user/logout').then((res) => {
								this.$router.push({
									name: 'login'
								})
								//销毁sid 与 token
								localStorage.removeItem('sid');
								localStorage.removeItem('token')
							})
						}
					}
				});
			}
		},
		created() {
			this.getUserMsg();
		},
		mounted() {
			//接收最新消息点击广播
			eventBus.$on('noticeClick', (data) => {
				let _this = this;
				this.pn = 1;
				this.getNoticeList();
				setTimeout(() => {
					//展示消息弹窗
					_this.showModal = true;
					//阅读最新一条消息
					_this.showDetail(0);
				}, 100);

			});
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/CommonHead/CommonHead.vue